import styled, { keyframes } from 'styled-components';
import { rgba } from 'polished';
import theme from '../../theme';

const rotate360 = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export default styled.span`
  content: " ";
  display: flex;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin: 1px;
  border-radius: 50%;
  border: 3px solid ${theme('colors.backgroundLight').apply(col => rgba(col, 0.3))};
  border-left-color: ${theme('colors.backgroundLight')};
  animation: ${rotate360} 1.2s linear infinite;
`;
